import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import BadgeNew from "../../../../BadgeNew";

import styles from "../MainMenuDropdown.scss";

const cx = classnames.bind(styles);

const Column = ({ children, title, isMobile, isNew, className }) => (
  <div className={cx("column", { mobile: isMobile }, className)}>
    {title && (
      <h5 className={cx("column-title")}>
        {title}
        {isNew && <BadgeNew />}
      </h5>
    )}

    <div className={cx("column-content")}>{children}</div>
  </div>
);

Column.propTypes = {
  title: PropTypes.node,
  isMobile: PropTypes.bool,
  children: PropTypes.node,
  isNew: PropTypes.bool,
  className: PropTypes.string,
};

export default Column;
